import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import { useInstitutionDetailsLocked } from '@/features/institution/hooks/useInstitutionDetails';
import type { InstitutionRegulatoryInformationOrDefaults } from '@/features/institution/regulatory-information/schema';

const InstitutionRegulatoryInformationFieldsetSupervision = () => {
  const form = useFormContext<InstitutionRegulatoryInformationOrDefaults>();
  const { locked } = useInstitutionDetailsLocked();
  const { t } = useTranslation();
  const isSupervisionLocked = locked.regulatoryInformation?.hasRegulatorySupervisionOrOversight !== undefined;

  return (
    <FormField
      name="hasRegulatorySupervisionOrOversight"
      control={form.control}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('institutionDetails.regulatoryInformation.hasRegulatorySupervisionOrOversight')}*</FormLabel>
          <FormControl>
            <RadioGroup
              defaultValue={field.value}
              disabled={isSupervisionLocked}
              variant="cards"
              aria-label={t('institutionDetails.regulatoryInformation.hasRegulatorySupervisionOrOversight')}
              onValueChange={field.onChange}
            >
              {BINARY_ANSWERS.map((answer) => (
                <FormItem key={answer}>
                  <RadioGroupItemCard variant="outline">
                    <FormControl>
                      <RadioGroupItem value={answer} />
                    </FormControl>
                    <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                  </RadioGroupItemCard>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
InstitutionRegulatoryInformationFieldsetSupervision.displayName = 'InstitutionRegulatoryInformationFieldsetSupervision';

export { InstitutionRegulatoryInformationFieldsetSupervision };
